export default {
  share: {
    planCard: {
      viewPriceTable: 'View Price Table',
      facilityDetails: 'Facility Details',
      soldOut: 'Sold out',
      planAutoSwitchNotice:
        '{{soldOutPlan}} is sold out on {{date}}. We have selected {{selectedPlan}}, which is still available.'
    },
    activityCategory: {
      RAILWAY_TICKET: 'Railway ticket',
      AIRPORT_TRANSPORTATION: 'Airport transportation',
      SHINKANSEN: 'Shinkansen',
      EXPRESS_BUS: 'Express bus',
      BUS_TOUR: 'Bus Tour',
      CRUISES: 'Cruises',
      RENTAL_CAR: 'Rental car',
      CHARTER: 'Charter',
      ATTRACTION: 'Attraction',
      THEME_PARK: 'Theme Park',
      MUSEUM_GALLERY: 'Museum & Gallery',
      AQUARIUM_ZOO: 'Aquarium & Zoo',
      TEMPLES_SHINES: 'Temples & Shrines',
      TOWER_BUILDING: 'Tower & Building',
      JAPANESE_RESTAURANT: 'Japanese Restaurant',
      WESTERN_RESTAURANT: 'Western Restaurant',
      CHINESE_RESTAURANT: 'Chinese Restaurant',
      OTHER_RESTAURANT: 'Other Restaurant',
      DESSERT_BEVERAGE: 'Dessert & Beverage',
      SIGHTSEEING_TOUR: 'Sightseeing Tour',
      MARINE_SPORTS: 'Marine sports',
      OUTDOOR_ACTIVITIES: 'Outdoor activities',
      ONSEN: 'Onsen',
      SPA_MASSAGE: 'Spa & Massage',
      JAPANESE_CULTURAL_EXPERIENCE: 'Japanese cultural experience',
      JAPANESE_CRAFT_EXPERIENCE: 'Japanese craft experience',
      JAPANESE_COOKING_EXPERIENCE: 'Japanese cooking experience',
      OTHER_EXPERIENCE: 'Other experience',
      HOTEL: 'Hotel',
      RYOKAN: 'Ryokan',
      VACATION_RENTAL: 'Vacation rental',
      BUNDLE: 'Bundle',
      PASS: 'Pass',
      OTHERS: 'Others'
    },
    product: {
      planDateFallbackNotice:
        'The date you selected ({{selectedDate}}) is sold out. We have switched your selection to the nearest available date ({{displayDate}}). Please confirm the date before completing your purchase.',
      planAutoSwitchConfirmPlan: 'Selected plan: "{{planTitle}}"',
      planAutoSwitchConfirmQuestion: 'Is this correct?',
      switchLanguageTitle: 'Change language'
    },
    priceTableDialog: {
      title: 'Price Table',
      dateFormat: '{{month}}/{{day}} ({{weekday}})',
      weekdays: {
        0: 'Sun',
        1: 'Mon',
        2: 'Tue',
        3: 'Wed',
        4: 'Thu',
        5: 'Fri',
        6: 'Sat'
      }
    },
    common: {
      account: 'Account',
      myPage: 'My Page',
      booking: 'My Booking',
      logout: 'Logout',
      save: 'Save',
      colon: ': ',
      multiply: '×',
      next: 'Next',
      return: 'Return',
      toPay: 'Payment',
      update: 'Update',
      search: 'Search',
      delete: 'Delete',
      space: ' ',
      comma: ',',
      titleSeparator: ' · ',
      add: 'Add-on Purchase',
      change: 'Change',
      confirm: 'Confirm',
      cancel: 'Cancel',
      searchPlaceholder: 'Search...',
      tilde: '~',
      showMore: 'Show More',
      notification: 'Notification',
      withParentheses: '{{value1}}（{{value2}}）',
      withDashSeparated: '{{val1}} - {{val2}}',
      selectTime: 'Select a time'
    },
    price: {
      primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
      prefix: '<currency>{{currency}}</currency><amount>{{amount}}</amount>',
      suffix: '<amount>{{amount}}</amount><currency>{{currency}}</currency>',
      jpyWord: 'JPY',
      cnyWord: 'CNY',
      jpySymbol: '¥'
    },
    footer: {
      terms: 'Terms of Use',
      cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
      copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.',
      recaptchaNotice:
        'This site is protected by reCAPTCHA and the Google <PrivacyLink>Privacy Policy</PrivacyLink> and <TermsLink>Terms of Service</TermsLink> apply.'
    },
    validation: {
      required: '{{field}} is required',
      invalid: 'Please enter a valid {{field}}',
      password:
        'Please enter a password with at least 8 characters, including uppercase, lowercase, symbols, and numbers',
      imageType: 'Please select an image file',
      fileSize: 'Please select a file less than {{size}}MB',
      range: 'Please enter a value between {{min}} and {{max}}',
      requiredSelect: 'Please select an {{field}} option',
      nameInvalid: '{{field}} contains invalid characters',
      romajiOnly: 'Please enter {{field}} in Roman letters',
      emailNotMatch: 'Email addresses do not match',
      emailAlreadyRegistered:
        'This email is already registered. Please log in instead.',
      ticketExpired:
        'Purchase time cannot be later than the activity start time.'
    },
    firebase: {
      'auth/wrong-password': 'The email or password entered is incorrect.',
      'auth/user-not-found': 'The email or password entered is incorrect.',
      'auth/email-already-in-use': 'Email already taken.',
      'auth/too-many-requests':
        'Too many failed login attempts, please resetting your password or try again later.'
    },
    apiErrors: {
      baseError: 'There is an error occurred.',
      clientError: 'An error occurred while sending API request.',
      serverError: 'API server failed to fulfil the request.',
      connectionError:
        'An error occurred while connecting to API server. Please check your network and try again later.',
      requestError: 'An error occurred while setting up an API request.',
      ARSError: {
        AFFILIATE_ID_REQUIRED:
          'Request failed. Please try again from your member page.',
        BOOKING_NOT_ENOUGH_ALLOTMENT:
          "Sorry, we don't have enough ticket inventory for the time slot that you have selected. Please choose a different date or time and try again.",
        BOOKING_NO_AVAILABILITY:
          "Sorry, we don't have enough ticket inventory for the time slot that you have selected. Please choose a different date or time and try again.",
        PERMISSION_DENIED: 'You do not have permission to access the resource.',
        NOT_FOUND: 'No resource found.',
        BOOKING_ALREADY_ISSUED: 'Redeemed or used voucher cannot be cancelled.',
        BOOKING_RESERVATION_OVERLIMIT: 'Reservation limit exceeded.',
        BOOKING_RATE_LIMITED:
          'Our website is currently experiencing high traffic.\nWe apologize for any inconvenience this may cause.\nPlease wait a little while, then proceed again using the ＜Payment＞ button below.'
      },
      lottery: {
        LOTTERY_ALREADY_APPLIED:
          'This ticket is limited to one purchase per person. You have already completed your application.'
      }
    },
    header: {
      openMenu: 'Open menu',
      closeMenu: 'Close menu'
    },
    login: {
      title: 'Login / Sign Up',
      caption: 'Please select a method to log in or register as a member.',
      appleLogin: 'Apple',
      googleLogin: 'Google',
      email: 'Email address',
      emailConfirm: 'Email address (confirmation)',
      password: 'Password',
      button: 'Login',
      forgotPassword: 'Forgot your password?',
      newAccount: 'Sign Up',
      signInAgree: `*You can easily log in and register as a member with a third party's account. \n *By registering as a member using your email address or a third party's account, you are deemed to have agreed to the <TermsLink>{{terms}}</TermsLink> and <PrivacyLink>{{privacy}}</PrivacyLink>.`,
      otpErrorMsg: 'The verification code is incorrect. Please try again.'
    },
    cart: {
      button: 'Cart',
      empty: 'The cart is empty',
      addToCart: 'Add to cart',
      totalCount: '{{count}} items',
      totalAmount: 'Total',
      unavailable: 'Unavailable',
      deleteConfirm: 'Are you sure you want to delete "{{activityName}}"?',
      availabilityConfirmTitle: 'Review cart contents',
      availabilityConfirmContent:
        'Your cart contains items that are either out of sales period or out of stock. Remove these items and continue to checkout?',
      availabilityConfirmProceed: 'Remove and continue',
      availabilityConfirmBack: 'Back to cart'
    },
    payment: {
      ticket: 'Ticket',
      plan: 'Plan',
      dateTime: 'Date & Time',
      validityPeriod: 'Validity Period',
      option: 'Option',
      discount: 'Discount',
      total: 'Total (tax incl.)',
      details: 'Details',
      submit: 'Submit',
      lotterySubmit: 'Apply for lottery',
      lotteryBeforeOpen: 'Lottery not yet open',
      lotteryClosed: 'Lottery closed',
      numberOfPeople: 'Guests',
      totalWithTax: 'Total (tax incl.)',
      viewPlan: 'View Plans',
      warn: 'Purchasing only {{unitName}} is not allowed',
      optionRequiredTag: 'Required',
      optionRequiredTip: 'Selecting at least one option is required.',
      optionQuantityShortage:
        'Options for {{quantity}} more people are required.',
      optionQuantityPartialShortage:
        'With your current selection, {{quantity}} more people are still required.',
      optionQuantityExcess:
        'The total options exceed the plan quantity by {{quantity}} people.',
      planQuantityRequired:
        'Please select the number of participants for the plan.'
    },
    password: {
      changePassword: 'Change password',
      resetPassword: 'Reset password',
      sendResetEmail: 'Send password reset email',
      sendResetEmailSuccess:
        'We send a link to {{email}}, please follow the link to reset your password.',
      oldPassword: 'Old password',
      newPassword: 'New password',
      changePasswordSuccess: 'Password changed successfully.'
    },
    emailVerification: {
      title: 'Verification email sent',
      description: 'A verification email has been sent to {{email}}.',
      instruction: 'Enter the verification code to complete registration',
      resend: 'Resend',
      verify: 'Login'
    },
    date: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    },
    profile: {
      title: 'Profile',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      confirmEmail: 'Email (confirmation)',
      password: 'Password',
      gender: 'Gender',
      birthday: 'Birthday',
      birthdayYear: 'Year',
      birthdayYearPlaceholder: 'Please select',
      birthdayMonth: 'Month',
      birthdayDay: 'Day',
      birthdayYearOption: '{{value}}',
      birthdayMonthOption: '{{value}}',
      birthdayDayOption: '{{value}}',
      country: 'Country or Region',
      prefecture: 'Prefecture',
      postCode: 'Postal code',
      postCodePlaceholder: 'e.g. 1234567 (7 digits, no hyphen)',
      genderOptions: {
        male: 'Male',
        female: 'Female',
        other: 'Other'
      },
      updateProfileSuccess: 'Profile updated successfully.',
      updateProfileFailed: 'Profile update failed, please try again later.',
      creditCardManagement: 'Credit Card Management',
      creditCardManagementGetErrMsg: 'Failed to get credit card info.'
    },
    weeks: {
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat'
    },
    empty: {
      message: 'No content found'
    },
    notFound: {
      subtitle: 'This page is not available.',
      returnHome: 'Return Home'
    },
    notFoundAuth: {
      subtitle: 'This page is not available.'
    },
    details: {
      title: 'View Details'
    },
    orderConfirm: {
      title: 'Confirmation Before Purchase (Important)',
      agree: 'I have read and agree to the above'
    },
    invoice: {
      title: 'Issue a Receipt',
      info: 'Receipt details',
      name: 'Received from',
      remarks: 'Remarks',
      cancelFee: 'Cancellation fee',
      cancelFeeAmount: 'Cancellation fee amount',
      email: 'Email to receive the receipt',
      check:
        'Note: Only one receipt per reservation will be issued. Any additional receipts for the same reservation will be marked as "Reissued”.',
      description: 'In Payment of',
      content: 'Description',
      confirm: 'Submit',
      success:
        'The receipt has been successfully generated and sent to your inbox. Please check your email: {{email}}',
      price: 'Payment amount',
      refundAmount: 'Refund amount'
    }
  },
  faq: {
    title: 'FAQ',
    bookingProcess: {
      title: 'Booking process',
      q1: 'How can I confirm if my booking has been confirmed?',
      a1: `Once your reservation is confirmed, we will email the address you provided during registration. This email will contain all the necessary information about your reservation, including a voucher.
          If you receive an email with a "Use E-Ticket" link, click on the link to access your ticket directly. You can also view your reservation details by clicking on the "Reservation Details" link in the email.`,
      q2: "What should I do if I haven't received the confirmation email for my booking?",
      a2: `Most of the products offer instant confirmation, it may take up to 5 minutes for your voucher to come through.
          If you don’t get a verification email within several minutes, please check your spam or junk folder in your inbox. The verification email will be sent from the address [@linktivity.co.jp].`,
      q3: 'Is it possible to get the voucher reissued?',
      a3: `Yes. You can check your booking information and voucher by logging in to your account.
1. After logging in to your account, click 'My Page' > 'Booking Information' at the top right of the screen.
2. Click ""View details"" of the booking
3. Select the voucher
And then click “Resend the voucher” to resend the voucher to the registered email address.
`
    },
    payments: {
      title: 'Payments',
      q1: 'What should I do if a booking fails during payment?',
      a1: `Please first check your booking history (Booking Information > Booking List) and check your email account for the confirmation email. If you still can’t find the booking information, please book again after 5 minutes.`,
      q2: 'How do I get a receipt?',
      a2: `At the moment, we are unable to issue receipts automatically. If you require a receipt, please send an email to <helpcenter@linktivity.co.jp> with the necessary details clearly stated, including the booking number, address, proviso, and amount.`,
      q3: 'Which payment methods are accepted?',
      a3: `You can pay with a credit card. Some products accept Alipay and WeChat Pay.
          We do not receive cash or payments at convenience stores.`,
      q4: 'What is 3D Secure?',
      a4: `3D Secure is an online identity authentication service that provides a safer way to make credit card payments over the Internet. This service helps prevent unauthorized access to your credit card information, such as "spoofing" or identity theft.
          When purchasing with a credit card registered with 3D Secure, the cardholder will be authenticated by entering a one-time password when ordering.
          Please note that the authentication methods may vary depending on the card company.`,
      q5: `Please guide me through the process of registering for 3D Secure.
            I am unsure whether my card supports this feature.`,
      a5: `To use 3D Secure, you need to register with your credit card company beforehand.
            To find out whether your card supports 3D Secure and the steps to set it up, please contact the contact information of your card issuer located on the back of your card.`,
      q6: `I did not receive my one-time password, and I am unsure of my 3D Secure password`,
      a6: `To complete the 3D Secure authentication process, you must enter either the password you have registered in advance with your credit card company or a one-time password. If you do not receive the one-time password, please check your spam folder, as it may have landed there.
          If you have forgotten your password or didn't receive the one-time password, you can contact your card issuer by referring to the contact details on the back of your card.`,
      q7: `Am I only allowed to use credit cards that are registered with 3D Secure?`,
      a7: `Please note that any cards not registered with 3D Secure cannot be used to make payments. This measure has been put in place to ensure the security of transactions. Due to the recent increase in fraudulent activities, the Ministry of Economy, Trade, and Industry has mandated all e-commerce websites to implement personal authentication (EMV 3-D Secure) by the end of March 2025.
          Moreover, in March 2023, the 'Credit Card Security Guidelines (4.0 Edition)' were issued, introducing new requirements for businesses involved in e-commerce, credit card processing, and payment agency services. These requirements include mandatory identity authentication and response procedures. As a result, the new internet reservation system will implement a payment system that complies with these guidelines and requires 3D Secure.
          `,
      q8: 'May I use a debit card?',
      a8: 'Certainly, it is possible to use a debit card.',
      q9: 'There are no issues with the 3D Secure settings or my card credit limit, and I can use the card on other websites. However, when I try to make payments, I encounter an error and need help.',
      a9: `If you encounter difficulties making a payment with a valid credit card, your credit card company's payment approval system may have canceled the payment to safeguard you from fraudulent use of your card. Unlike humans, computers use several factors to predict and make decisions on a case-by-case basis. Therefore, there could be instances when payments may not be feasible.
  
          We apologize for the inconvenience caused and suggest that you try one of the following options:
          - Try using a different card for payment
          - Wait for a while and try making the payment again
          - Contact your credit card company, explain the name of the ticket you want to reserve and the situation, and request them to correct their fraud detection and payment approval systems to avoid such errors in the future.`,
      q10: 'Although I received a usage notification from my credit card company, I have yet to receive any reservation confirmation email, and there is no reservation information on My Page.',
      a10: `Please note that one of the situations mentioned below could be causing an issue with your reservation:
          - The email address you provided may be incorrect due to a spelling error.
          - You may have used a different email address to register your reservation than the one you usually use.
          - Although your card limit has been secured, payment and reservation may not have been completed due to some error.
          If you have a specific email address in mind, please try logging into My Page using that address. If you are unable to log in, please send an email to the LINKTIVITY customer support team at <helpcenter@linktivity.co.jp> with the following information so that we can check your payment and reservation records:
          - Reserver's name (in English)
          - Preferred date of participation
          - Date and time of payment (e.g., 3/2 19:00)
          - Last 3 digits of the payment card
          - The expiry date of the payment card
          - Amount of money paid
          - Email address used to make the reservation`
    },
    changesAndCancellations: {
      title: 'Change & Cancel',
      q1: 'I made a booking by mistake. How do I cancel it?',
      a1: `For products that can be canceled, please apply for the cancellation by following the steps below.
          1. After logging in to your account, click "Account"> "Reservation Information" at the top right of the screen.
          2. Click "See details" of the booking
          3. Click "Start Cancel"> "Cancel"`,
      q2: 'When will I get my refund?',
      a2: `It depends on your credit card company. Please contact your credit card company if you would like to know the exact time.`,
      q3: 'Can I make changes to my booking?',
      a3: `Please cancel the booking and book a new one.
          Please check the cancellation policy of each plan to confirm whether you can cancel the product and more details.`
    },
    accounts: {
      title: 'Accounts',
      q1: 'How do I register an account?',
      a1: `You can register an account by clicking “Login” at the top right of the site or trying to make a new booking.
          Please check your email address carefully when registering.
          You can also use a third-party account (i.e., Apple or Google account) to sign in to our site.`,
      q2: 'How do I log in to my account?',
      a2: `Please click “Login” at the top right of the site to log in to your account.`,
      q3: 'What should I do if I forget my password?',
      a3: `Please click “Forgot your password?” on the login page and follow the steps to reset your password.`
    },
    environment: {
      title: 'Others',
      q1: 'What are the supported browsers?',
      a1: `Supported browsers:
  
          ・ Firefox (latest version)
          ・ Safari (latest version)
          ・ Google Chrome (latest version)`,
      q2: 'What is the sending domain (email address) of the verification email?',
      a2: `The verification email will be sent from the address [@linktivity.co.jp]. Try adding [@linktivity.co.jp] to your email contact list as it may be classified as spam email.`
    },
    ticket: {
      title: 'Using E-Tickets',
      q1: 'What is one-time password authentication?',
      a1: `This reservation system uses a one-time password as a security measure to prevent unauthorized use of E-tickets by third parties. The password can only be used once and is required for authentication when the customer's access environment, such as device or browser, changes.
  
          If you open an E-ticket before using it in a different access environment than when purchasing the ticket, you will be asked to enter the one-time password to authenticate your access.
          
          To avoid any confusion or inconvenience on the day of your visit, we recommend that you open and verify your E-ticket on the same device and browser you will be using. 
          
          For instance, if you open the E-ticket for the first time on your smartphone, one-time password authentication is not required. However, if you open the E-ticket on a different device, such as a family member's smartphone, you will be prompted to enter the one-time password.
          
          It is important to note that the email address used for authentication during the first access will be registered in the system. Therefore, even if you open the ticket on a different device for the third time, a one-time password will be sent to the email address registered initially. We advise that you use an email address that you can access on the day of your visit to receive the one-time password.`,
      q2: 'A message appeared saying, "Your access environment has changed." How do I view my e-ticket?',
      a2: `To ensure the security of the customer's account, a one-time password authentication is required if they open their e-ticket on a device or browser different from the one on which it was first opened. To complete this process, follow these steps:
  
          1. Enter the email address to which the one-time password will be sent.
          *We suggest you provide an email address that can be accessed on the event day to receive the one-time password.
          2. Check the email address you provided to see if you have received the one-time password.
          4. Enter the one-time password you received in the email.
          5. If you have entered the one-time password correctly, the authentication process is complete, and you can now display your E-ticket.`,
      q3: `I haven't received the one-time password email.`,
      a3: `If you have not received the one-time password email, kindly check your spam folder. If you've specified a domain, please configure the settings to allow "@linktivity.co.jp." Your email address may be incorrect if you still haven't received the email. Please enter a valid email address or try a different one.`,
      q4: 'Could I modify the email address to which the one-time password will be sent?',
      a4: `Once you initiate the one-time password authentication process, the email address to which the one-time password is sent cannot be modified. After completing the process, a one-time password will be sent to the registered email address during the initiation phase. For better convenience, it's recommended to register an email address that can be accessed on the device you plan to use for the e-ticket, such as the smartphone you will carry to the venue.`,
      q5: `I receive one-time password emails even when I'm not using it. Could this be fraudulent?`,
      a5: `If you keep receiving verification letters for one-time passwords, there could be two reasons for that:
  
          - You forwarded the e-ticket (voucher) to other travelers:
          If your traveling companion opens the e-ticket after you have opened it and completed the one-time password verification, the system will send you a one-time password verification letter due to the different devices they use. As a result, whenever your fellow travelers connect to the e-ticket, the system will send a one-time password verification letter to your password inbox (the mailbox you logged in when verifying the one-time password).
          
          - Unauthorized use: Your e-ticket could have been stolen if you had not forwarded it to others. Please consider booking the ticket if necessary.`,
      q6: `I received a password from an email address I don't recognize.`,
      a6: `If you receive a one-time password from an unfamiliar email address, it could be for the following reasons:
  
          - Forwarding of e-tickets (vouchers) to other travelers:
          Suppose you open the e-ticket after other travelers have accessed it and completed the one-time password verification. In that case, the system will send you a one-time password verification email due to using different devices. At this point, the one-time password email will be sent to the traveler's email address (used to log in during the verification process). The system will automatically send a password verification email to this address. If this happens, it is advisable to first check with your fellow travelers.
          
          - Unauthorized use:
          It may have been stolen if you have not shared your e-ticket with anyone else. Please consider booking the ticket if necessary.`
    }
  },
  privacy: {
    lastUpdated: 'Last Updated: March 18, 2022',
    companyName: 'Linktivity Inc.',
    title: 'Privacy Policy',
    personalInfoProtectionPolicy: 'Personal Information Protection Policy',
    personalInfoProtectionDescription:
      'Linktivity Inc. (hereinafter "Company") collects personal information from customers on our reservation website LINKTIVITY and other platforms. The Company considers it extremely important to protect customer personal information to enable customers to make reservations with peace of mind and convenience. We handle personal information in accordance with the provisions set forth below.',
    customerDataManager: 'Customer Data Manager',
    companyAddress:
      '19F Hibiya Park Front, 2-1-6 Uchisaiwaicho, Chiyoda Ward, Tokyo 100-0011',
    acquisition: 'Acquisition',
    acquisitionDescription:
      'The Company acquires only the minimum necessary personal information required to achieve its stated purposes of use, and only after obtaining customer consent when required by law.',
    usage: 'Usage',
    usageDescription:
      'The Company uses personal information obtained from customers only to achieve the stated purposes of use.',
    storage: 'Storage and Retention',
    storageDescription:
      'The Company maintains and stores personal information with careful attention to system security to prevent unauthorized disclosure to external parties.',
    destruction: 'Destruction and Deletion',
    destructionDescription:
      'The Company promptly destroys personal data that is no longer needed for use, without delay from the point at which it is no longer needed.',
    customerInquiry: 'Response to Customer Inquiries',
    customerInquiryDescription:
      'The Company responds in accordance with applicable laws to requests from customers regarding the purpose of use of held personal data, requests for disclosure, requests for correction/addition/deletion, requests for suspension/deletion of use, and requests to stop third-party provision.',
    safetyMeasures: 'Safety Management Measures',
    safetyMeasuresDescription:
      'The Company ensures that all staff involved in LINKTIVITY services understand the importance of personal information through education, and implements necessary and appropriate security measures for the protection of personal information.',
    tableOfContents: 'Table of Contents',
    policy1: {
      title: 'Personal Information We Collect and Purposes of Use',
      description:
        'The Company collects and uses personal information including customer addresses, names, dates of birth, contact information, email addresses, and passport numbers for the following stated purposes of use. The Company does not collect sensitive personal information without customer consent. In cases where the purpose of use of personal information is not publicly disclosed at the time of collection, the Company notifies the customer of or publicly discloses the purpose of use of the personal information being collected. The Company does not collect personal information from children under 13 without parental consent. When personal information of children under 13 is provided, we will treat it as having obtained parental consent, but if it becomes clear that consent was not obtained, we will not use the personal information for purposes other than contacting the parent and related purposes.',
      serviceUsage: {
        title: 'For LINKTIVITY Service Use (Member Registration, etc.)',
        description:
          'For LINKTIVITY service use, customer personal information is shared internally within the Company.',
        legalBasis:
          'It is necessary to provide the services and features requested by customers.'
      },
      ticketPurchase: {
        title: 'For Ticket Purchase Applications',
        infoItems:
          'The Company collects customer names, payment information, passport numbers, and information related to customer health status including health conditions and medical history when processing ticket purchase applications from product providers.',
        purpose:
          'The Company collects and uses customer personal information to verify ticket purchase eligibility from product providers and process payment for tickets and related fees. For these purposes, the Company may provide customer personal information to product providers, transportation companies, payment processors, and other service providers (including overseas providers).',
        legalBasis:
          'It is necessary to provide the services and features requested by customers.'
      },
      newsletter: {
        title:
          'For Sending Newsletters (Email Magazines, etc.) and Customer Communications',
        legalBasis: 'Collected based on customer consent.'
      },
      advertising: {
        title:
          'For Advertising through Social Media and Ad Distribution Platforms',
        legalBasis: 'Collected based on customer consent.'
      },
      survey: {
        title: 'For Survey Participation Requests',
        legalBasis:
          'Collected based on customer consent for improvement of our reservation website, products, and services.'
      },
      analysis: {
        title: 'For Customer Information Analysis and Management',
        legalBasis:
          'It is necessary to pursue and protect legitimate customer interests by improving our reservation website, products, and services.'
      },
      fraudDetection: {
        title:
          'For Detection of Fraudulent Use of Credit Cards and Similar Instruments',
        legalBasis:
          'It is necessary to ensure the security of customer credit cards and pursue legitimate customer interests.'
      }
    },
    policy2: {
      title: 'Third-Party Provision of Personal Data',
      description:
        'The Company does not provide personal data obtained from customers to third parties except in the following cases.',
      case1:
        'When the customer has given prior consent to provision of personal data to third parties (including product providers, overseas travel agencies, social media providers, ad distribution service companies, and other service providers) through agreement with this Privacy Policy or by other means.',
      case2:
        'When handling of personal data has been outsourced to third parties within the scope necessary to achieve the stated purposes of use.',
      case3: 'When provision is required by law.',
      case4:
        'When necessary to protect human life, body, or property, and obtaining customer consent would be difficult.',
      case5:
        'When specially necessary for improving public health or promoting the healthy development of children, and obtaining customer consent would be difficult.',
      case6:
        'When cooperation is necessary for government or local government implementation of duties prescribed by law, and obtaining customer consent would hinder the execution of such duties.'
    },

    policy3: {
      title: 'Delegation of Handling of Personal Data',
      description:
        'When the Company delegates handling of customer personal data to third parties within the scope necessary to achieve its stated purposes of use, the Company provides necessary and appropriate oversight to the delegated parties. If a delegated party further delegates to another party, the Company directly or indirectly oversees whether the delegated party provides necessary and appropriate oversight to the re-delegated party. The same applies when a re-delegated party further delegates.'
    },
    policy4: {
      title: 'Collection of Cookie Information, etc.',
      cookie: {
        title: 'Cookies',
        description1:
          "A cookie is a data file stored on a user's hard drive that contains information about the user. The Company does not use cookies to identify individuals. Cookies are session cookies and are not retained once the user closes the browser. Cookies are used for improving customer service, customizing our website, measuring advertising effectiveness, and related purposes.",
        description2:
          'The Company analyzes cookies as statistical data to identify customer interests and concerns and utilizes this information. Cookies are also used to prevent unauthorized access.',
        description3:
          'Cookies can be disabled at customer preference, but doing so will prevent customers from making reservations on LINKTIVITY.'
      },
      logFile: {
        title: 'Log Files',
        description1:
          'The Company automatically collects certain information and saves it to log files. This specific information includes IP (Internet Protocol) addresses, browser types, ISP (Internet Service Provider) names, referring/exit pages, operating systems, and date/time stamps. The Company uses this information for monitoring unauthorized access and customer trend analysis, website management, and tracking customer behavior on our site.',
        description2:
          'However, the Company uses this information in a way that does not identify specific individuals, and does not use the information collected for purposes other than those stated above.'
      },
      webBeacon: {
        title: 'Web Beacons',
        description:
          'The Company uses web beacons for access analysis and affiliate programs. The Company does not use web beacons for purposes other than those stated above or to identify specific individuals.'
      },
      statisticalAnalysis: {
        title: 'Statistical Analysis',
        description1:
          'The Company uses third-party access analysis tools to identify which sites and services are popular, and records pages accessed by customers within LINKTIVITY and page history.',
        description2:
          'The Company uses this data to provide content and advertising tailored to the interests of customers who have shown interest in specific areas within LINKTIVITY.',
        description3:
          'The Company may also collect statistical information that does not identify individuals. Furthermore, cookie information collected by the Company and cookie information collected by other parties may be made viewable to both parties on the third-party access analysis tool platform.'
      }
    },
    policy5: {
      title: 'Handling of Anonymized Information',
      creation: {
        title: 'Creation of Anonymized Information',
        description1:
          'When creating anonymized information, the Company takes the following measures. Anonymized information is information about individuals obtained by processing personal information in a manner that prevents identification of specific individuals, in accordance with legal requirements, such that the original personal information cannot be restored.',
        description2:
          '① Processing in accordance with legally prescribed standards ② Implementing safety management measures to prevent disclosure of deleted information and information about processing methods ③ Publicly disclosing the items of information about individuals contained in the created anonymized information ④ Not engaging in acts to identify the original individual from the personal information used to create the anonymized information'
      },
      provision: {
        title: 'Provision of Anonymized Information',
        description:
          'When providing anonymized information to third parties, the Company publicly discloses the items of information about individuals contained in the anonymized information and the method of provision, and clearly indicates to the recipient that the information being provided is anonymized information.'
      },
      disclosure: {
        title: 'Disclosure Regarding Anonymized Information',
        creationSubtitle: 'Regarding Creation of Anonymized Information',
        creationDescription:
          'Regarding the following customer personal information held by the Company, the Company continuously creates anonymized information while taking appropriate measures to prevent identification of specific individuals and to ensure that the original personal information cannot be restored.',
        itemsTitle:
          'Items of Information About Individuals Contained in Anonymized Information',
        itemsDescription:
          'Information collected regarding platform service provision: purchase date, participation date, voucher language, sales amount range, number of participants, reservation status (confirmed or canceled), supplier location and prefecture information, travel agency location country.',
        thirdPartyTitle: 'Third-Party Provision of Anonymized Information',
        thirdPartyDescription:
          'Regarding anonymized information created or held by the Company, the Company continuously provides this information to third parties while clearly indicating that the information is anonymized information.',
        provisionMethod:
          'Password-protected electronic files sent through electronic communication means (email, server upload, API integration, etc.) or physical media (such as DVD).'
      }
    },
    policy6: {
      title: 'Safety Management Measures for Personal Data',
      description1:
        'The Company implements organizational, technical, and physical safety management measures to prevent leakage, theft, misuse, unauthorized access, alteration, and destruction of personal data. Access to the server where the Company stores personal data is restricted to authorized employees with ID and password access, and access to certain personal data is granted only to the minimum necessary employees for data management.',
      description2:
        'Furthermore, personal data including credit card information is stored in a secure environment distributed across multiple data centers. The Company uses Secure Sockets Layer (SSL) encryption for all pages related to reservation transactions. Using an SSL-compliant browser maintains the confidentiality of personal data and credit card information transmitted over the Internet.',
      description3:
        'Employees of the Company who handle customer personal data use password-protected screen savers when away from their terminals.',
      description4:
        'Furthermore, the Company conducts educational training regarding the importance of personal information once a month for certain departments and at least twice a year company-wide. The Company also maintains records of such training.'
    },
    policy7: {
      title: 'Rights of Customers Regarding Handling of Personal Data',
      description:
        'Based on the EU General Data Protection Regulation (GDPR) 2016/679 dated April 27, 2016, customers have the following rights regarding processing of personal data:',
      right1: 'Right of access',
      right2: 'Right to rectification',
      right3:
        'Right to erasure (right to be forgotten) and right to restrict processing',
      right4: 'Data portability right',
      right5: 'Right to object',
      right6:
        'Right not to be subject to automated decision-making based on profiling, including.'
    },
    policy8: {
      title: 'Requests for Disclosure, Rectification, Suspension of Use, etc.',
      description1:
        'The Company responds to requests from customers for notification of purpose of use of held personal data, requests for disclosure, requests for correction/addition/deletion, requests for suspension/deletion of use, and requests to stop third-party provision (collectively referred to as "requests for disclosure, etc.") through the contact information listed in section 11 below.',
      description2:
        "Additionally, the Company responds to customer wishes to change and confirm member information and suspend distribution of email magazines through the customer's account page."
    },
    policy9: {
      title: 'Regarding External Links',
      description:
        'The LINKTIVITY homepage contains links to other websites. This Privacy Policy applies only to information collected through the LINKTIVITY homepage, and the Company is not responsible for the privacy policies or content of other websites. Customers are requested to read the privacy policies of linked websites and confirm how their personal information is handled.'
    },
    policy10: {
      title: 'Changes to Privacy Policy',
      description:
        'The Company publishes this Privacy Policy on the LINKTIVITY homepage so that customers can always know what personal information the Company collects, for what purposes, and how it is used. Changes to this Privacy Policy are also published on the LINKTIVITY homepage and disclosed to customers.'
    },
    policy11: {
      title: 'Contact Information',
      description1:
        "For questions regarding the Company's Privacy Policy, the Company's personal information protection efforts, the collection and use of customer personal information, or to make a request for disclosure, etc., please use the contact form below. A representative will respond within 5 business days.",
      company: 'Linktivity Inc.',
      address:
        '19F Hibiya Park Front, 2-1-6 Uchisaiwaicho, Chiyoda Ward, Tokyo 100-0011',
      dpoContact: 'Data Protection Officer Contact: dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: 'Personal Information Collected',
      specificPurpose: 'Specific Purpose of Use',
      legalBasis: 'Legal Basis:',
      provisionMethod: 'Method of Provision'
    }
  },
  terms: {
    title: 'LINKTIVITY利用規約',
    lastUpdated: '最終更新日 2020年05月01日',
    intro: {
      company: 'リンクティビティ株式会社（以下、「当社」といいます）は、',
      serviceDesc:
        'のサービスのご利用に関して、以下のとおりLINKTIVITY利用規約（以下、「本規約」といいます）を定めています。',
      agreement:
        'LINKTIVITYをご利用いただいた場合は、本規約に同意したものとみなしますので、LINKTIVITYのサービスをご利用いただきます際には、必ず本規約をお読みください。なお、本規約は、必要に応じ変更することがございますので、ご利用の際には最新の内容をご参照ください。',
      privacyNote: '＊個人情報の取り扱いについては、',
      privacyLinkText: '「個人情報保護方針」',
      privacyNoteSuffix: 'をお読みください。'
    },
    article1: {
      title: '第一条 規約の目的',
      content:
        '本規約は当社が運営する商品・サービス等の場貸し（プラットフォーム）販売サイト「LINKTIVITY」のサービス利用者に適用するものです。本サービスの利用者は、あらかじめ本規約に同意した上で、本サービスを利用するものとします。また、本規約は予告なく変更することがあります。'
    },
    article2: {
      title: '第二条 会員登録',
      items: [
        '「会員」とは、本規約を承認の上、本規約に基づき本サービスの提供を受けるために当社の指定する会員登録手続を完了し、当社が会員として承認した個人とします。ただし、承認後でも、当社が会員として不適当と判断した場合には承認の取り消しを行うことがあります。',
        '会員登録の際の登録情報に関して、いかなる虚偽の申告も認めないものとします。本人、登録情報（氏名、メールアドレス等）、パスワードは、それぞれ一つずつのみ対応するものとし、同一人物による複数の会員としての登録は認めないものとします。',
        '登録情報に変更が生じた場合は、会員は速やかに所定の変更手続きを行うものとします。'
      ]
    },
    article3: {
      title: '第三条 商品提供者が提供する情報',
      content:
        '当社は、LINKTIVITYにおいて、商品提供者が提供する内容、料金、購入可能日時、取消規定（キャンセルポリシー）等購入に必要な情報(以下、「購入関連情報」といいます)、および商品提供者に関する情報を会員に提供しますが、購入関連情報は、商品提供者の責任において提供されるものであり、当社が故意または過失による情報の非伝達のため発生したものを除き、当社は情報の内容については一切責任を負うものではありません。'
    },
    article4: {
      title: '第四条 契約成立',
      content:
        'LINKTIVITYのプラットフォームでは会員が購入する商品、サービス等の提供に関する契約は、会員と商品提供者との間で直接締結されます。LINKTIVITYにおける商品、サービス等の掲載は、商品提供者への申し込みを行うためのものであり、当社はその申し込みを当該商品提供者に代わって自由に承認または却下できます。本利用規約は、会員によるLINKTIVITYサービスの使用を規定するものであり、商品提供者への購入申し込みを行うためにLINKTIVITYを使用する場合も含みます ただし、会員が予約する商品・サービス等の提供は、LINKTIVITYに表示される契約条件、予約手続中に提示される情報、およびプ商品・サービス等の提供に関する法的な契約の締結先である商品提供者が定める契約条件に従うものとします。'
    },
    article5: {
      title: '第五条 代金のお支払',
      content: [
        'LINKTIVITYは商品提供者の代金回収代理業者として、会員のお支払い情報を取得し、支払いを処理します。会員は、商品・サービス等の購入時に当社へクレジットカードまたは当社が提供する決済手段にて代金を支払うものとします。外貨表記ので、当社が日本円でクレジットカード決済額または当社が提供する決済手段の請求金額を決定する場合は、当社が定めるレートにて日本円に換算することとします。',
        '但し、一部については、ページで指定された次のいずれかの方法で支払うものとします。'
      ]
    },
    article6: {
      title: '第六条 商品提供者が提供する商品・サービスの内容・品質',
      content:
        '当社は、商品提供者が提供する商品・サービスの内容・品質については一切責任を負うものではなく、会員と商品提供者との間で生じるトラブル、紛争もしくは苦情、会員が被る損害については、会員が商品提供者との間で解決するものとし、当社はこれらにつき何ら責任を負うものではありません。'
    },
    article7: {
      title: '第七条 利用環境',
      items: [
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の購入に必要な通信機器・ソフトウェア・通信手段等必要なものの全てを用意するものとします。',
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の利用に必要なインターネットに接続可能なスマートフォン・ソフトウェア・通信手段等必要なものの全てを用意するものとします。'
      ]
    },
    article8: {
      title: '第八条 会員の自己都合による購入の取消、取消料',
      items: [
        '会員の自己都合で購入を取消す場合の取消料は、該当商品提供者が定める取消規約（キャンセルポリシー）に則ります。',
        '当社は代金支払時と代金返金時の為替差損益については一切責任を負うものではありません。',
        '購入の取消は、原則、LINKTIVITYのマイページより行うものとします。但し、利用日直前で、商品提供者に直接電話で連絡がとれ、かつ商品提供者が購入の取消を受付けた場合は、後日、マイページよりLINKTIVITYへ、その旨連絡することにより取消手続きは完了するものとします。'
      ]
    },
    article9: {
      title: '第九条 商品提供者による取消、返金',
      content:
        '商品・サービス等の内容変更、中止に伴う会員への告知は商品提供者が行い、当社は商品・サービス等の変更、中止に伴なう責任は一切負いません。ただし、当社は商品提供者の決定・依頼に基づき販売した商品・サービス等の内容の変更や中止による商品・サービス等の払い戻し業務を代行する場合があります。'
    },
    article10: {
      title: '第十条 パスワードの管理',
      items: [
        '会員は、パスワードの管理責任を負うものとします。',
        '会員は、メールアドレス、パスワードを第三者に利用させたり、貸与、譲渡、名義変更、売買、質入等を行うことはできないものとします。',
        '会員のパスワードの管理不十分、使用上の過誤、第三者の使用等による損害の責任は、会員が負うものとし、当社は一切責任を負いません。'
      ]
    },
    article11: {
      title: '第十一条 会員登録情報の取扱い',
      items: [
        '会員登録の際に会員が登録した個人情報（以下、「登録情報」といいます）は、当社の個人情報保護方針に従い、当社が保有、管理するものとします。',
        {
          text: '当社は、登録情報のうち、特定の個人の識別が可能な情報（以下「個人情報」という。）を、第三者に開示しないものとします。ただし、以下の場合を除きます。',
          subItems: [
            '情報開示についてお客様の同意がある場合',
            '個人情報保護のための守秘義務契約を結んだ業務委託先に対しサービスを履行するために必要な個人情報を提供する場合',
            'サービス向上目的で個人情報を集計および分析し、個人を識別または特定できない状態で第三者に開示または提供する場合',
            '裁判所の発する令状その他裁判所の判断に従い開示する場合'
          ],
          note: 'なお、当社が取得した個人情報に関する、利用目的その他取り扱いについての詳細は「個人情報保護方針」をお読みください。'
        }
      ]
    },
    article12: {
      title: '第十二条 会員の禁止事項',
      intro:
        '会員は、LINKTIVITYを利用する際に、以下の行為またはそのおそれのある行為を行ってはならないものとします。',
      items: [
        '本規約に違反する行為',
        '公序良俗または法令に違反する行為',
        '当社、他の会員または第三者の著作権、肖像権、その他知的所有権を侵害する行為',
        '他の会員または第三者を誹謗・中傷する行為',
        '他の会員または第三者に不利益を与える行為',
        '当社の事業あるいは当社の提供するサービスの運営を妨害する行為',
        '営利を目的とする行為',
        '会員として得た権利を、当社の事前の同意を得ることなく第三者に譲渡および貸与する行為',
        'その他、当社が不適当と判断する行為'
      ]
    },
    article13: {
      title: '第十三条 会員発信情報の削除又は修正',
      intro:
        '当社は、会員が送信した情報のうち、以下のいずれかに該当するまたはそのおそれがあるものを、会員の承諾なく、全部または一部を削除し、またはこれに対し当社が必要と判断する修正を行うことができるものとします。',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当すると当社が判断するもの',
        '事実に明らかに反すると当社が判断するもの',
        'その他当社が不適当と判断するもの'
      ]
    },
    article14: {
      title: '第十四条 会員資格の抹消',
      intro:
        '会員が以下の事由のいずれかに該当する場合、当社は会員に事前の通知することなく、また会員に対して何らの責任を負うことなく、会員資格を抹消することができるものとします',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当する行為を行った場合',
        'その他、本規約のいずれかに違反した場合。',
        'その他、会員として不適格と当社が判断した場合'
      ]
    },
    article15: {
      title: '第十五条 サービスの変更・中断・中止',
      items: [
        '当社は、会員に事前に通知することなく、サービス内容を変更、中断または中止する場合があります。',
        '本サービス内容の変更または中断に伴い、会員に不利益または損害が発生した場合であっても、当社はその責任を負わないものとします。',
        '当社は、会員に対して１ヶ月前に通知することにより、サービスの提供を中止することができるものとします。'
      ]
    },
    article16: {
      title: '第十六条 著作権および財産権',
      content:
        'LINKTIVITYに表示されるすべての内容に関する著作権および財産権は、当社および当社にそれらの内容を提供している、商品提供者、提携先、広告主に帰属しています。利用者および会員は、当社、商品提供者、提携先、広告主の事前の文書による承諾を受けた場合を除いて、それらの内容を複製、公開、譲渡、貸与、翻訳、転載、送信、使用許諾、再利用しないことなどに同意するものとします。また、利用者および会員がこれらの行為によって得た利益相当額を当社が請求できる権利を有していることとします。'
    },
    article17: {
      title: '第十七条 免責・責任制限',
      items: [
        '当社は、会員と商品提供者との間で生じた損害、会員が本規約に違反して生じた損害、商品・サービス等のチケットへの引き換えにおいて当社の責に帰さない事由により発生した損害については、一切の責任を負わないものとします。',
        '商品提供者は、当社とは独立した契約主体であり、商品提供者による、いかなる行為、過失、怠慢、代理行為、保証や、商品・サービス等の参加に関連する会員の負傷、死亡、所有物の損傷・遺失テロリズムに帰する損害、その他あらゆる損害等について、当社は一切責任を負うものではありません。',
        '当社は、当社の直接の管理範囲を超えた原因により生じた、商品・サービス等の遅延、キャンセル、重複購入、ストライキに対する責任を負わないものとします。また、政府当局や裁判所令状等による内容変更、キャンセル、遅延、追加費用の発生等についても応じる義務を負いません。',
        '当社は、当社に故意または過失がある場合においても、会員に対し、本サービスの提供に関連して会員に発生した現実かつ直接の通常損害以外の損害を負担しません。'
      ]
    },
    article18: {
      title: '第十八条 本規約の変更',
      content:
        '本規約の内容について、当社は必要に応じ変更できるものとします。本規約を変更した場合は、本画面上の変更をもってその変更が終了したものとし、都度、会員への通知は行わないものとします。'
    },
    article19: {
      title: '第十九条 合意管轄',
      content:
        '本規約に関する一切の紛争については、東京地方裁判所を第一審の専属管轄裁判所とします。'
    },
    article20: {
      title: '第二十条 協議',
      content:
        '本規約に定めのない事項又は本規約に関する疑義が生じた場合には、関係当事者間にて誠意をもって協議し、円満に解決するよう努めるものとします。'
    }
  },
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: 'Service Name',
    companyName: 'Seller',
    representative: 'Representative',
    address: 'Address',
    contact: 'Contact',
    paymentTerms: 'Payment Method and Timing',
    deliverySchedule: 'Delivery Schedule',
    sellingPrice: 'Selling Price',
    shippingFee: 'Shipping Fee',
    additionalFee: 'Additional Fees',
    salesRestrictions: 'Sales Restrictions',
    returnsAndCancellations: 'Returns and Cancellations',
    otherConditions: 'Other Conditions'
  },
  requireForm: {
    lastName: 'Last name',
    firstName: 'First name',
    participantInfo: 'User info',
    requiredBookingInfo: 'Required information',
    BookingFieldMethod: {
      PER_PARTICIPANT: 'Per participant',
      PER_BOOKING: 'Per booking'
    },
    bookingFields: {
      participantEmailAddress: 'participant email address',
      hotelName: 'Hotel name',
      hotelAddress: 'Hotel address',
      hotelReservationLastName: 'Hotel reservation last name',
      hotelReservationFirstName: 'Hotel reservation first name',
      hotelReservationName: 'Hotel reservation name',
      hotelTel: 'Hotel telephone number',
      arrivalDate: 'Arrival date',
      arrivalTime: 'Arrival time',
      arrivalFlightNumber: 'Arrival flight number',
      departureDate: 'Departure date',
      departureTime: 'Departure time',
      departureFlightNumber: 'Departure flight number',
      destinationEmail: 'Destination email',
      destinationTel: 'Destination tel',
      gender: 'Gender',
      agentChannelRegion: 'Agent channel country / region',
      agentChannelLanguage: 'Agent channel language',
      participantResidentRegion: 'Participant resident country / region',
      participantLanguage: 'Participant language',
      passengersQuantity: 'Number of passengers',
      prescriptionMaskQuantityFree:
        'Number of prescription masks needed (free)',
      prescriptionMaskQuantityPaid:
        'Number of prescription masks needed (charged, pay locally)',
      preferredStartTime: 'Preferred Start time',
      preferredPickUpLocation: 'Pick-up location',
      preferredDropOffLocation: 'Drop-off location',
      participantsQuantity: 'Number of participants',
      luggageQuantity: 'Number of luggage (total)',
      childrenWithoutSeatQuantity: 'Number of children who do not need a seat',
      childSeatQuantityPaid:
        'Number of child seats needed (charged, pay locally)',
      childSeatQuantityFree: 'Number of child seats needed (free)',
      guideJa: 'Do you need a Japanese speaking guide?',
      driverJa: 'Do you need a Japanese speaking driver?',
      guideEn: 'Do you need an English speaking guide?',
      driverEn: 'Do you need an English speaking driver?',
      guideZh: 'Do you need a Chinese speaking guide?',
      driverZh: 'Do you need a Chinese speaking driver?',
      guideKo: 'Do you need a Korean speaking guide?',
      driverKo: 'Do you need a Korean speaking driver?',
      preferredGuideLanguageCode: "Preferred guide's language",
      preferredDriverLanguageCode: "Preferred driver's language",
      passportNationality: 'Nationality',
      passportFirstName:
        "Participant's given name (your name in alphabet as written in your passport)",
      passportLastName:
        "Participant's surname (your name in alphabet as written in your passport)",
      dateOfBirth: 'Date of birth',
      age: 'Age',
      passportNumber: 'Passport number',
      eyesight: 'Eyesight',
      weightKg: 'Weight (kg)',
      heightCm: 'Height (cm)',
      shoeSizeCm: 'Shoe size (cm)',
      weightLbs: 'Weight (lbs)',
      heightIn: 'Height (ft/in)',
      clothesSize: 'Clothes size',
      vegetarianMeals: 'Do you need vegetarian meals?',
      divingExperienceTimes: 'How many times have you dived before?',
      rentalEquipmentsFree: 'Do you need rental equipments? (free)',
      rentalEquipmentsPayLocally:
        'Do you need rental equipments? (charged, pay locally)',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      yes: 'Yes',
      no: 'No'
    }
  },
  components: {
    selectOption: {
      title: 'Option',
      quantity: 'Quantity: {{quantity}}',
      addCart: 'Add to Cart',
      planSelect: 'Select a plan',
      dateSelect: 'Select a date',
      dateLabel: 'Date',
      timeSelect: 'Select a time',
      quantitySelect: 'Select a quantity',
      quantitySelectLabel: 'Quantity',
      soldOut: 'Sold Out',
      total: 'Total',
      viewDetail: 'View Details',
      unitRatioNotCounted: '*This option is not counted toward the total.',
      unitRatioCounted: '*Each unit counts as {{quantity}} people.'
    },
    planDetailDrawer: {
      title: 'Plan Details',
      planContent: 'Plan Content',
      meetingPlace: 'Meeting Place',
      cancellationPolicy: 'Cancellation Policy',
      capacity: 'Capacity',
      maxCapacity: 'Maximum Capacity',
      minCapacity: 'Minimum Capacity',
      bookingAcceptance: 'Booking Acceptance',
      bookingDeadline: 'Booking Deadline',
      voucherExpirationPeriod: 'Voucher Expiration Period',
      inclusion: 'Inclusion',
      participationLocations: 'Participation Locations',
      participationLocationKind: {
        MAP_OF_MEETING_POINT: 'Map of Meeting Point',
        NOTE_OF_LOCATION_AND_DIRECTION: 'Note of Location and Direction',
        LANDMARKS_TO_MEETING_POINT: 'Landmarks to Meeting Point',
        PICK_UP_CAR: 'Pick Up Car',
        PICK_UP_GUIDE: 'Pick Up Guide',
        ITINERARY: 'Itinerary',
        PARKING: 'Parking'
      },
      restrictions: 'Restrictions',
      requirements: 'Requirements',
      attireItems: 'Attire Items',
      otherInfo: 'Other Information'
    },
    payment: {
      ticket: 'Ticket',
      option: 'Option',
      total: 'Total (Including Tax)',
      details: 'Details',
      submit: 'Proceed to Order'
    },
    bookInfo: {
      plan: 'Plan',
      dateTime: 'Date & Time',
      validityPeriod: 'Validity Period',
      ticket: 'Ticket',
      option: 'Option',
      discount: 'Discount',
      total: 'Total (Including Tax)'
    },
    coupon: {
      title: 'Coupon',
      caption: 'Enter your coupon code',
      apply: 'Apply'
    },
    bookingDetailVoucher: {
      pdf: 'Printable PDF',
      html: 'View Voucher'
    },
    collapsibleCard: {
      stockStatus: {
        available: 'Available',
        limited: 'Limited',
        soldOut: 'Sold Out'
      }
    },
    unitCard: {
      minCapacityWarning:
        'A minimum of {{quantity}} is required. Please check the quantity.',
      maxCapacityReached: 'The purchase limit has been reached.',
      optionQuantityLimitReached:
        "This option can't be added with your current selection."
    }
  },
  bookingDetail: {
    title: 'Booking Details',
    meetingPoint: 'Entry Location Guide',
    beforeTrip: 'Pre-use Checklist',
    reservationInfo: 'Reservation Information',
    redemption: 'Use E-ticket',
    digitalTicketWaiting:
      '*Digital ticket will be displayed here after order confirmation',
    inclusion: 'Included items',
    restrictions: 'Restrictions',
    requirements: 'Requirements before and during participation',
    attireItems: 'Clothing and belongings required for participation',
    otherInfo: 'Other',
    cancelSuccess: 'Your booking was cancelled successfully.',
    sendToEmailSuccess: 'Email sent successfully, please check your inbox',
    sendToEmailError: 'Failed to send email, please try again later'
  },
  bookResult: {
    pendingTitle: 'Confirming Payment',
    pendingMessage:
      'Your order is not yet complete. Please wait until the process is finished.',
    successMessage:
      'Thank you for your reservation. The reservation voucher will be sent to the email address you registered immediately, please check your inbox.',
    failedMessage: 'Payment failed. Please book again.',
    timeoutMessage:
      'Timeout. Please wait a moment, then reload the page or check whether the booking succeeded in the notification email or on the booking information screen below.',
    backToProduct: 'Back to Product'
  },
  booking: {
    title: 'Booking Information',
    bookingNumber: 'Booking Number',
    viewDetail: 'View Details',
    toBooking: 'Re-book',
    bookingRange: {
      oneMonth: 'Within 1 month',
      threeMonths: 'Within 3 months',
      sixMonths: 'Within 6 months'
    },
    plan: 'Plan',
    participationTime: 'Participation date and time',
    validityPeriod: 'Validity Period',
    count: 'Quantity',
    option: 'Options',
    paidAmount: 'Amount Paid',
    customerName: 'Reservation Name',
    refundAmount: 'Refund Amount',
    orderCompletionTime: 'Booking Time',
    adultTicket: 'Adult',
    childTicket: 'Child',
    status: {
      BOOKING_STATUS_CONFIRMED: 'Booking completed',
      BOOKING_STATUS_PENDING: 'Booking submitted. Confirming ticket issuance',
      BOOKING_STATUS_CANCEL_PENDING: 'Cancel Pending',
      BOOKING_STATUS_CANCELED: 'Cancelled',
      BOOKING_STATUS_USED: 'Used',
      BOOKING_STATUS_WITHDRAWN: 'Reservation Failed',
      BOOKING_STATUS_APPLIED: 'Lottery application received',
      BOOKING_STATUS_APPLIED_DECLINED: 'Lottery application declined',
      BOOKING_STATUS_DECLINED: 'Lottery application declined'
    }
  }
};
